import React, { useState } from "react";
import {
  FileDownload,
  ImageIcon,
  PDFFileIcon,
  UpArrow,
} from "../../../assets/svg/AllSvg";

const DocumentsList = ({ documentArray }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <>
      <div className="bg-primary_shades_light rounded-2xl h-full space-y-3 py-4 px-5">
        <div className="flex space-x-2">
          <p className="text-dark_primary">Documents</p>
          <span className="w-6 h-6 bg-green text-white rounded-full flex justify-center items-center">
            {documentArray?.length}
          </span>
        </div>
        <button
          className="flex justify-between items-center w-full"
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <p className="text-theme">Files</p>
          {isOpen ? <UpArrow /> : <UpArrow className="rotate-180" />}
        </button>
        {isOpen && (
          <>
            {documentArray?.length ? (
              <>
                {documentArray?.map((element, index) => {
                  return (
                    <div
                      className="grid grid-cols-4 justify-between items-center"
                      key={index}
                    >
                      <div className="col-span-3 flex items-center space-x-2 w-full">
                        {element?.document?.document_type === "doc" ? (
                          <PDFFileIcon />
                        ) : (
                          <ImageIcon />
                        )}
                        <p className="truncate text-sm max-w-full">
                          {element?.document?.name}
                        </p>
                      </div>

                      <a
                        href={element?.document?.url}
                        download={element?.document?.name}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-block ml-auto"
                      >
                        <FileDownload />
                      </a>
                    </div>
                  );
                })}
              </>
            ) : (
              <div className="py-2 text-center">“No File Currently”</div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default DocumentsList;
